import { PerfData } from 'owa-editor/lib/utils/PerfData';
import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';

export default function logEditorPerf(perfData: PerfData) {
    const data: { [key: string]: number } = {};
    let consoleLog = 'Editor Typing Perf:\n';

    for (const key of Object.keys(perfData)) {
        const perfEntry = perfData[key];
        const average = perfEntry.totalTime / perfEntry.count;
        data[key] = average;
        consoleLog += `${key}:{${perfEntry.totalTime}/${perfEntry.count}=${average}}\n`;
    }

    logUsage('EditorTypingPerf', data);

    if (consoleLog != '') {
        trace.info(consoleLog);
    }
}
